import OfferConfig from "../../Features/OfferConfiguration/OfferConfig";

export const OfferPage = () => <OfferConfig/>

export default OfferPage;
